// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rm-name-box[data-v-768a90f4] {\n  background-color: #e6eaea;\n  padding: 0.65rem 1.1rem;\n  border-radius: 15px;\n}\n.rm-name-box h6[data-v-768a90f4] {\n  font-size: 0.88rem;\n  font-weight: 500;\n}", ""]);
// Exports
module.exports = exports;
